module.exports = __webpack_public_path__ + "static/img/bass_muff.e9dc0da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls37-1/bass_muff.png
// module id = kmJ8
// module chunks = 12